var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Manages the site inspection agreement step for Dynaren claims and persists the choice in the claim extraData.
 * touches: claim store, Dynaren extraData, site inspection agreement, Claims IA design system components.
 * invariants: the radio UI uses true/false/null while the persisted agreement uses visio/denied/null; confirmation is enabled only once a choice is made; the claim is updated only with a non-null value.
 * inputs: claim extraData, declaration step, the user's site inspection choice.
 * outputs: renders the question and choices, maps the UI value to the persisted format, saves the agreement to the claim.
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { UiButton, UiCard, UiSpinner } from '@claims-ia/design-system';
import { namespace } from 'vuex-class';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { Step } from '@shared/claim/steps';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
const claim = namespace('claim');
let SiteInspection = class SiteInspection extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/appointment/expertByVisio.svg');
        this.isUpdatingClaim = false;
        this.yesOrNoChoices = YES_OR_NO_CHOICES;
        this.siteInspectionAgreementValue = null;
    }
    mounted() {
        var _a;
        const extraData = this.claim.extraData || {};
        this.siteInspectionAgreementValue = (_a = extraData.siteInspectionAgreement) !== null && _a !== void 0 ? _a : null;
    }
    // Pour le binding radio (true/false/null)
    get siteInspectionAgreementModel() {
        if (this.siteInspectionAgreementValue === 'visio')
            return true;
        if (this.siteInspectionAgreementValue === 'denied')
            return false;
        return null;
    }
    set siteInspectionAgreementModel(value) {
        this.siteInspectionAgreementValue = value === true ? 'visio' : value === false ? 'denied' : null;
    }
    get isLoading() {
        return this.isUpdatingClaim;
    }
    get imgVisioAlt() {
        return this.$tc('site.inspection.image.alt');
    }
    get question() {
        return this.$tc('site.inspection.question');
    }
    get isValidationButtonDisabled() {
        return this.siteInspectionAgreementValue === null;
    }
    get isSavingAgreement() {
        return this.isUpdatingClaim;
    }
    get siteAgreementWording() {
        return {
            submitLabel: this.$tc('site.inspection.submit.label'),
        };
    }
    async confirmUserChoice() {
        if (this.siteInspectionAgreementValue !== null) {
            this.isUpdatingClaim = true;
            const extraData = this.claim.extraData || {};
            await this.updateAndSaveClaim({
                step: Step.SiteInspection,
                claimPayload: {
                    extraData: {
                        ...extraData,
                        siteInspectionAgreement: this.siteInspectionAgreementValue,
                    },
                },
            });
            this.isUpdatingClaim = false;
        }
    }
};
__decorate([
    claim.State('claim')
], SiteInspection.prototype, "claim", void 0);
__decorate([
    claim.Action('updateAndSaveClaim')
], SiteInspection.prototype, "updateAndSaveClaim", void 0);
SiteInspection = __decorate([
    Component({
        components: {
            UiSpinner,
            UiButton,
            UiCard,
            RadioPrimaryButton,
        },
        props: {
            step: {
                type: String,
                required: true,
            },
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            goBack: null,
        },
    })
], SiteInspection);
export default SiteInspection;
